import { Alert, AlertDescription, AlertTitle } from "@coval/ui"

export const WorkspacesBetaNotice = () => (
  <Alert variant="info">
    <AlertTitle>Workspaces are in beta</AlertTitle>
    <AlertDescription>
      This feature is in beta and might still have bugs.
    </AlertDescription>
  </Alert>
)
